import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const createPropertySlice = createSlice({
  name: 'createProperty',
  initialState,
  reducers: {
    setStepData(state, action) {
      Object.assign(state, action.payload)
    },
    clearStepData() {
      return initialState
    },
  },
})

export const { setStepData, clearStepData } = createPropertySlice.actions
export default createPropertySlice.reducer
